import { Injectable } from '@angular/core';
import { QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { PaymentMethodQuery, PaymentMethodQueryHandlerBase } from '@skylab-shared/business';
export { PaymentMethodQueryHandlerBase };

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PaymentMethodQuery)
@Wrapper(PaymentMethodQueryHandlerBase)
export class PaymentMethodQueryHandler {
    public constructor(
        rootContext: RootContext,
    ) { }
}
